import ReactPlayer from "react-player/lazy";

import { cn } from "@/helpers/className";

// The reason for this component is this issue: https://github.com/cookpete/react-player/issues/1428#issuecomment-1107908096
export const VideoPlayer = ({
  playerRef,
  videoUrl,
  boxDisplay,
  playBtn,
  posterUrl,
}) => {
  return (
    <ReactPlayer
      ref={playerRef}
      url={videoUrl}
      className={cn(boxDisplay && "overflow-hidden rounded-2xl")}
      width="100%"
      height="100%"
      playing
      playIcon={playBtn}
      light={posterUrl}
    />
  );
};

export default VideoPlayer;
